<template>
  <!-- 资质荣誉 -->
  <div>
    <pageNav :currentActiveNav="'资质荣誉'" v-if="isMobile"></pageNav>
    <pageHeader></pageHeader>
    <div class="content">
      <pageNav :currentActiveNav="'资质荣誉'" v-if="!isMobile"></pageNav>
      <div class="company">
        <div class="title">{{ config.title }}</div>
        <div class="company-content">
          <div class="company-left">{{ config.desc }}</div>
          <div class="company-right">
            {{ config.companyDesc }}
          </div>
        </div>
      </div>
    </div>
    <div class="content-img">
      <el-image :src="config.imgUrl"></el-image>
    </div>
    <div class="company content-des">
      <div class="company-content">
        <div class="company-left">{{ config.contentDesc }}</div>
        <div class="company-right">
          {{ config.contentDescMore }}
        </div>
      </div>
    </div>
    <!-- 认证 -->
    <auth />
    <!-- 资质荣誉 -->
    <div class="honor" v-if="!isMobile">
      <div class="honor-title">{{ config.honorTitle }}</div>
      <div style="padding: 50px 50px 100px 50px">
        <el-image :src="config.honorImg" :key="config.honorImg" lazy></el-image>
      </div>
    </div>
    <div style="padding:0 16px;" v-if="isMobile">
      <div class="title">荣誉资质</div>
      <div class="honor-img" >
        <div class="honor-img-item" v-for="(imgItem, index) in config.honorImgList" :key="imgItem.src">
          <img :src="imgItem.src"></img>
          <div class="honor-img-desc">{{ imgItem.desc }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { config } from "./js/qualification_honor";
import pageHeader from "./components/header.vue";
import pageNav from "./components/navMenu.vue";
import auth from "../home/components/auth.vue"

export default {
  name: "",
  components: { pageHeader, pageNav, auth },
  data() {
    return {
      config: config,
    };
  },
  watch: {},
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    }
  },
  mounted() {
    console.log('config.honorImgList', config);

  },
  methods: {},
};
</script>

<style scoped lang="less">
.content {
  padding: 45px 68px 100px;
}

.company {
  .title {
    font-size: 40px;
    margin-bottom: 60px;
  }

  .company-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;

    .company-left {
      font-size: 24px;
    }

    .company-right {
      font-size: 20px;
    }
  }
}

.content-img {
  background: @grayBgColor;
  padding: 85px 0;
  text-align: center;
}

.content-des {
  padding: 100px 68px 82px;
}

.honor {
  margin: 0 68px;

  .honor-title {
    font-size: 40px;
    margin-bottom: 49px;
  }

  .honor-img {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    &:last-child {
      border-bottom: 1px solid @mainGrayColor3;
    }

    .honor-img-item {
      border-top: 1px solid @mainGrayColor3;
      border-left: 1px solid @mainGrayColor3;
      position: relative;
      overflow: hidden;

      &:nth-child(3n) {
        border-right: 1px solid @mainGrayColor3;
      }

      &:hover {
        .honor-img-desc {
          display: block;
          animation: moveUp 1s ease forwards;
        }
      }

      .honor-img-desc {
        display: none;
        position: absolute;
        bottom: -50px;
        background: @mainColor;
        font-size: 20px;
        width: 100%;
        text-align: center;
        padding: 20px 0;
      }
    }
  }
}

@keyframes moveUp {
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-50px);
  }
}



@media @mobile {
  .content {
    padding: 40px 16px 60px;
  }

  .company {
    .title {
      font-size: 20px;
      margin-bottom: 30px;
      line-height: 1.3;
    }

    .company-content {
      grid-template-columns: 1fr;
      grid-column-gap: 0;
      grid-row-gap: 16px;

      .company-left {
        font-size: 17px;
        line-height: 1.5;
      }

      .company-right {
        font-size: 12px;
        line-height: 1.5;
        color: #6E6D6F;
      }
    }
  }

  .content-img {
    padding: 30px 16px;

    img {
      width: 100%;
      height: auto;
      object-fit: cover;
    }
  }

  .content-des {
    padding: 40px 16px;
  }

  .title {
    font-size: 17px;
  }

  .honor-img {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr; // 保持3列布局，贴合截图效果
    margin-bottom: 40px;
    .honor-img-item {
      border-top: 1px #D6D6D6 solid;
      margin-top: 20px;
      display: flex;
      flex-direction: column;
      align-items: center; // 图片+文字水平居中

      // 移动端图片样式
      img {
        width: 100%;
        height: 100%;
        object-fit: contain; // 保持图片完整，不拉伸变形
      }

      // 图片描述文字
      .honor-img-desc {
        font-size: 12px;
        color: black; // 继承文字颜色
      }
    }
  }
}
</style>